import React, { useEffect, useState } from "react"
import { observer } from "mobx-react-lite"
import { IMG } from "./common/CONST"
import { ISignupRequest } from "../types/ISignupRequest"
import * as BaseAPI from "../requests/TrinityAPI"
import { useNavigate } from "react-router-dom"
import { useStore } from "../stores/RootStoreContext"
import { IErrorModel } from "../types/error/IErrorModel"

export const SignUp = observer(() => {
  const navigate = useNavigate()
  const [signupRequest, setSignupRequest] = useState<ISignupRequest>()
  const { userStore } = useStore()
  const [passwdError, setPasswdError] = useState("")
  const [errorModel, setErrorModel] = useState<IErrorModel>()
  const [successSignup, setSuccessSignup] = useState(false)
  const [wait, setWait] = useState(false)

  useEffect(() => {
    if (userStore.getToken) {
      window.location.href = "/dashboard"
    }
  }, [])

  const submit = () => {
    if (!signupRequest || wait) return
    setWait(true)
    setErrorModel(undefined)
    if (
      !signupRequest.password ||
      signupRequest.password !== signupRequest.rePassword ||
      signupRequest.password.trim().length === 0
    ) {
      setPasswdError("Пароли не совпадают")
      setWait(false)
      return
    }
    BaseAPI.signUp(signupRequest, response => {
      if (response.status === 200) {
        setSuccessSignup(true)
      } else {
        setWait(false)
        setErrorModel(response.data)
      }
    })
  }

  return (
    <div className="registration-container">
      <div className="reg-left-img-block">
        <img src={IMG.main_logo} alt="" className="img-main-enter" />
      </div>
      <div className="reg-right-block">
        <div className="block-form">
          <h2 className="heading-form">Регистрация</h2>
          {successSignup ? (
            <p className="text-block">
              На ваш E-mail была выслана ссылка для подтверждения регистрации. Для активации вашего аккаунта перейдите
              по ссылке (если в течение 5 мин. ссылка не пришла, проверьте папку "Спам")
            </p>
          ) : (
            <>
              <fieldset>
                <legend>E-mail</legend>
                <input
                  type="email"
                  required
                  className={
                    errorModel?.code && (errorModel.code === "001-008" || errorModel.code === "001-005")
                      ? "input-form-error"
                      : "input-form"
                  }
                  placeholder="example@example.com"
                  onChange={e => setSignupRequest({ ...signupRequest, username: e.target.value })}
                />
                {errorModel?.code && (errorModel.code === "001-008" || errorModel.code === "001-005") ? (
                  <p className="error-form">{errorModel.message}</p>
                ) : (
                  <></>
                )}
              </fieldset>
              <fieldset>
                <legend>Имя</legend>
                <input
                  type="text"
                  required
                  className="input-form"
                  placeholder="Иван Иванов"
                  onChange={e => setSignupRequest({ ...signupRequest, name: e.target.value })}
                />
              </fieldset>
              <fieldset>
                <legend>Пароль</legend>
                <input
                  type="password"
                  required
                  className="input-form"
                  placeholder="A—a Z—z 1 * / -"
                  onChange={e => setSignupRequest({ ...signupRequest, password: e.target.value })}
                />
              </fieldset>
              <fieldset>
                <legend>Повторите пароль</legend>
                <input
                  type="password"
                  required
                  className="input-form"
                  placeholder="A—a Z—z 1 * / -"
                  onChange={e => setSignupRequest({ ...signupRequest, rePassword: e.target.value })}
                />
                {passwdError ? <p className="error-form">{passwdError}</p> : <></>}
              </fieldset>
              {(errorModel?.message && errorModel.code === "001-001") || errorModel?.code === "001-009" ? (
                <p className="error-form">{errorModel.message}</p>
              ) : (
                <></>
              )}
              <div className="flex-btn-justify">
                <input
                  type="submit"
                  value={wait ? "Подождите..." : "Зарегистрироваться"}
                  onClick={submit}
                  className="btn"
                />
                <button onClick={() => navigate("/signin")} className="btn white-btn">
                  Я уже зарегистрирован
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
})
